/**
 * Handles video element functionality
 * @param {string} video element's class selector
 * @param {string} control - play/pause btn's class selector
 */

export default function initSimpleVideoPlayer(container, control) {

  const videoElement = container.querySelector('video');
  const playPauseButton = container.querySelector(control);
  videoElement.play();

  /**
  * Toggles the video element's play/pause state
  */
  const togglePlay = function() {

    if (videoElement && playPauseButton) {
      playPauseButton.addEventListener('click', () => {
        playPauseButton.classList.toggle('playing');
        if (playPauseButton.classList.contains('playing')) {
          videoElement.play();
        }
        else {
          videoElement.pause();
        }
      });
    }
  }
  togglePlay();
}
